import { render, staticRenderFns } from "./contact-detail-changes.vue?vue&type=template&id=22060126&scoped=true"
import script from "./contact-detail-changes.vue?vue&type=script&lang=js"
export * from "./contact-detail-changes.vue?vue&type=script&lang=js"
import style0 from "./contact-detail-changes.vue?vue&type=style&index=0&id=22060126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22060126",
  null
  
)

export default component.exports